import React, { useState, useCallback, useEffect } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import shortid from 'shortid';

import Button from './Button';
import Modal, { ModalProps } from 'react-bootstrap/Modal';

import Text from './Text';
import { RootState } from '../config/store';
import { toggleContinueShoppingModal } from '../actions/ui';
import { Link } from 'react-router-dom';
import BackgroundImage from './BackgroundImage';

export interface ContinueShoppingModalProps extends ModalProps {
  // onClose: () => void;
}
const ContinueShoppingModal: React.FC<ContinueShoppingModalProps> = ({
  ...others
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const show = useSelector<RootState, boolean>(
    (state) => state.ui.showContinueShoppingModal,
  );
  
  const onHide = useCallback(() => {
    dispatch(toggleContinueShoppingModal(false));
  }, [dispatch]);

  return (
    <Modal {...others} centered={true} show={show} onHide={onHide}>
      <Modal.Body>
        <div>
          <BackgroundImage height="70px"
            src={`${process.env.PUBLIC_URL}/assets/img/cart-dialog.png`}
          ></BackgroundImage>
          <Text className="m-0" color="black" as="h4" align="center">
            Continue Shopping
          </Text>
        </div>
        <div className={classes.buttons}>
          <Button
            className={classes.CheckoutButton}
            color="secondary"
          >
            <Link
              to="cart"
              onClick={e => {onHide()}}
            >
              Checkout
            </Link>
          </Button>
          <Button
            onClick={e=> {onHide()}}
          >Continue</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const useStyles = createUseStyles({
  CheckoutButton: {
    "height": "44px",
    "marginInlineEnd": "16px",
    '& a': {
      "color": "#522583"
    }
  },
  buttons: {
    "marginTop": "20px",
    "textAlign": "right"
  }
});

export default ContinueShoppingModal;
